// Libs
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { GetSharedKitsSettings } from '../actions/sharedKits';

const useSharedKitsSettings = () => {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.sharedKits?.settings);

  useEffect(() => {
    if (!settings) {
      dispatch(GetSharedKitsSettings());
    }
  }, [dispatch, settings]);

  return {
    canCreate: !!settings?.canCreate,
    subgroups: settings?.subgroups || [],
    isSettingsLoaded: !!settings,
  };
};

export default useSharedKitsSettings;
